import {route} from 'react-router-typesafe-routes';

export const crmRoutesPath = route({
  path: 'crm',
});
